module.exports = __webpack_public_path__ + "static/media/br.ef701aba.svg";